/**
 * InformationView state updated Actions
 */
export const INFORMATION_VIEW_STATE_UPDATED = 'INFORMATION_VIEW_STATE_UPDATED';
export function informationViewStateUpdated(informationViewState) {
  return {
    type: INFORMATION_VIEW_STATE_UPDATED,
    informationViewState: informationViewState,
  };
}
